"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Drawer;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _styled = require("./styled");
var _globalization = require("@planday-corp/globalization");
var _hooks = require("../../../hooks");
var _KeyboardGuard = _interopRequireDefault(require("../../../behaviour/KeyboardGuard"));
var _FilterBanner = _interopRequireDefault(require("../../../indicators/FilterBanner"));
var _Banner = _interopRequireDefault(require("../../../indicators/Banner"));
var _Text = _interopRequireDefault(require("../../../text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function Drawer(_ref) {
  var _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus,
    _ref$modal = _ref.modal,
    modal = _ref$modal === void 0 ? true : _ref$modal,
    _ref$closeIcon = _ref.closeIcon,
    closeIcon = _ref$closeIcon === void 0 ? false : _ref$closeIcon,
    _ref$isBlocked = _ref.isBlocked,
    isBlocked = _ref$isBlocked === void 0 ? false : _ref$isBlocked,
    _ref$overModal = _ref.overModal,
    overModal = _ref$overModal === void 0 ? false : _ref$overModal,
    title = _ref.title,
    children = _ref.children,
    header = _ref.header,
    advancedPane = _ref.advancedPane,
    advancedPaneWidth = _ref.advancedPaneWidth,
    buttons = _ref.buttons,
    banner = _ref.banner,
    onClose = _ref.onClose,
    closeIconLabel = _ref.closeIconLabel;
  var _useContext = (0, _react.useContext)(_globalization.GlobalizationContext),
    i18n = _useContext.i18n;
  var portalElem = (0, _hooks.usePortal)({
    name: 'drawer'
  });
  var clickedTarget = (0, _react.useRef)();
  var drawerRef;
  (0, _react.useEffect)(function () {
    if (autoFocus && drawerRef && drawerRef.current && drawerRef.current.focus) {
      drawerRef.current.focus();
    }
  }, []);
  var handleOverlayMouseDown = function handleOverlayMouseDown(event) {
    clickedTarget.current = event.target;
  };
  var handleOverlayMouseUp = function handleOverlayMouseUp(event) {
    if (clickedTarget.current === event.target && clickedTarget.current === event.currentTarget) {
      onClose();
    }
  };
  var bannerEl = null;
  if (banner && banner.type !== 'filter') {
    bannerEl = /*#__PURE__*/_react.default.createElement(_Banner.default, banner, /*#__PURE__*/_react.default.createElement(_Text.default, null, banner.title));
  }
  if (banner && banner.type === 'filter') {
    bannerEl = /*#__PURE__*/_react.default.createElement(_FilterBanner.default, {
      dismissLabel: banner.dismissLabel,
      onDismiss: banner.onDismiss
    }, /*#__PURE__*/_react.default.createElement(_Text.default, null, banner.title));
  }
  var drawerWithKeyboardGuard = /*#__PURE__*/_react.default.createElement(_KeyboardGuard.default, {
    onEscKey: onClose
  }, function (ref) {
    drawerRef = ref;
    return /*#__PURE__*/_react.default.createElement(_styled.Wrapper, {
      ref: drawerRef,
      tabIndex: -1,
      role: "dialog",
      "aria-label": i18n.getText(title).toString(),
      $overModal: overModal
    }, /*#__PURE__*/_react.default.createElement(_styled.Pane, null, /*#__PURE__*/_react.default.createElement(_styled.Header, null, /*#__PURE__*/_react.default.createElement(_styled.Title, {
      element: "h1",
      size: "title2",
      value: title
    }), header), bannerEl, /*#__PURE__*/_react.default.createElement(_styled.Body, null, children), buttons && /*#__PURE__*/_react.default.createElement(_styled.Footer, null, buttons), closeIcon && /*#__PURE__*/_react.default.createElement(_styled.CloseIcon, {
      onClick: function onClick() {
        return onClose();
      },
      iconName: "closeBig",
      label: closeIconLabel || {
        term: 'CommonTerms.Close',
        fallback: 'Close'
      }
    })), advancedPane && /*#__PURE__*/_react.default.createElement(_styled.AdvancedPane, {
      $width: advancedPaneWidth
    }, /*#__PURE__*/_react.default.createElement(_styled.AdvancedBody, null, advancedPane)));
  });
  return /*#__PURE__*/_reactDom.default.createPortal(modal ? /*#__PURE__*/_react.default.createElement(_styled.FadeInOverlay, {
    onMouseDown: !isBlocked ? handleOverlayMouseDown : undefined,
    onMouseUp: !isBlocked ? handleOverlayMouseUp : undefined,
    $overModal: overModal
  }, drawerWithKeyboardGuard) : drawerWithKeyboardGuard, portalElem);
}